import { getParsedICUMessages } from '@vocab/core/icu-handler';
export { createTranslationFile } from '@vocab/core/translation-file';

const createLanguage = (moduleId, loadImport) => {
  let promiseValue;
  return {
    getValue: locale => {
      // @ts-expect-error Missing webpack types
      if (!__webpack_modules__[moduleId]) {
        return undefined;
      }

      // @ts-expect-error Missing webpack types
      const m = __webpack_require__(moduleId);
      return getParsedICUMessages(m, locale);
    },
    load: () => {
      if (!promiseValue) {
        promiseValue = loadImport();
      }
      return promiseValue;
    }
  };
};

export { createLanguage };
